// API helpers for IPDSectionConfiguration (facility-level IPD settings,
// e.g. the auto_housekeeping toggle).
import axios from "axios";

const BASE =
  process.env.REACT_APP_BACKEND_ROUTE_URL ||
  "https://manage-dev.hlthtek.com/app/api/";

function authHeaders() {
  const token = sessionStorage.getItem("accessToken") || "";
  return { Authorization: `Bearer ${token}` };
}

export async function getSectionConfiguration(facilityId, configurationType) {
  const params = new URLSearchParams({ facility_id: facilityId, configuration_type: configurationType });
  const res = await axios.get(`${BASE}ipd_section_configuration/?${params.toString()}`, {
    headers: authHeaders(),
  });
  return res?.data;
}

export async function saveSectionConfiguration(facilityId, configurationType, configuration) {
  const res = await axios.post(
    `${BASE}ipd_section_configuration/`,
    { facility_id: facilityId, configuration_type: configurationType, configuration },
    { headers: { ...authHeaders(), "Content-Type": "application/json" } }
  );
  return res?.data;
}
